import { styled as o, OutlinedInput as e } from "@mui/material";
import { jsx as r } from "react/jsx-runtime";
const u = o(e)`
  & {
    background-color: #161616;
    border-radius: 2px;
    color: #ffffff;
  }

  & .MuiOutlinedInput-input {
    font-size: 12px;
    line-height: 14px;
    padding: 4px;
  }

  &:hover .MuiOutlinedInput-notchedOutline,
  & .MuiOutlinedInput-notchedOutline {
    border-color: #161616;
    border-radius: 2px;
    border-width: 1px;
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #ffbf36;
    border-width: 1px;
  }
`, i = (t) => /* @__PURE__ */ r(u, {
  ...t
});
export {
  i as default
};
//# sourceMappingURL=TextInput.js.map
